import React from 'react';
import {ComponentFrame} from "../../frame/ComponentFrame";
import {SectionHeader} from "../section-header/SectionHeader";
import {Container} from 'reactstrap';
import {ContactUsForm} from "../../forms/ContactUsForm";

export class ContactUsFormSection extends React.Component {

  render(){
    return (
      <ComponentFrame tag="section"
                      style={{ position: 'relative' }}
                      header={
                        <SectionHeader align="center"
                                       color="white"
                                       title="LET US CONTACT YOU" />
                      }>
        <Container className="contact-v3-container">
          <div className="contact-v3-desc">Just tell us how we can reach you, and we'll get back to you as soon as possible.</div>
          <ContactUsForm/>
        </Container>
      </ComponentFrame>
    );
  }
}






// WEBPACK FOOTER //
// ./src/components/contact-us/ContactUsFormSection.js